import logo from '../eye-mask.svg'

export const UserGuide = () => {

    return (
        <div className='absolute' style={{ height: '100%', width: '100%', overflow: 'scroll', padding: 8 }}>
            <img src={logo} alt="" style={{width: 80, height: 60, marginTop: 10}} />
            <h3>How to use SaytoMe?</h3>
            <p>The App usage seems complex at first but trust us, it's pretty simple and enjoyable once you get used to it.</p>
            <p>We are still in the process of developing a standard user guide.</p>
            <p>Please hold on for a few days. Should be up anytime!</p>
            <p>You will be notified when it's up :)</p>
        </div>
    );
}